'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
const theme_LegacyTypography = require('../../../theme/LegacyTypography.cjs.js');
require('react');
const theme_LegacyColorMap = require('../../../theme/LegacyColorMap.cjs.js');
const components_display_Avatar_Avatar = require('../../display/Avatar/Avatar.cjs.js');
require('clsx');
const components_marketing_TestimonialSolo_TestimonialMapping = require('../TestimonialSolo/TestimonialMapping.cjs.js');
const components_marketing_TestimonialSolo_TestimonialSolo = require('../TestimonialSolo/TestimonialSolo.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const CommonStyles = styleEncapsulation.labelStyles("TestimonialCommon", {
  quote: react.css`
    ${styleMixins_reset.boxSizing};
    ${theme_LegacyTypography.LegacyTypography.smallPrint1}
    color: ${theme_Colors.Colors.GrayWarm10};
    margin-bottom: 10px;

    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.tablet}px) {
      margin-bottom: 20px;
      ${theme_LegacyTypography.LegacyTypography.paragraph3}
    }

    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.desktop}px) {
      margin-bottom: 20px;
      ${theme_LegacyTypography.LegacyTypography.paragraph1}
      color: ${theme_Colors.Colors.GrayWarm9};
    }
  `,
  author: react.css`
    ${styleMixins_reset.boxSizing};
    ${theme_LegacyTypography.LegacyTypography.smallPrint1Bold}
    margin: 0;
    color: ${theme_Colors.Colors.GrayWarm9};

    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.tablet}px) {
      ${theme_LegacyTypography.LegacyTypography.paragraph3Bold}
    }
  `,
  company: react.css`
    ${styleMixins_reset.boxSizing};
    ${theme_LegacyTypography.LegacyTypography.smallPrint1}
    margin: 0;
    color: ${theme_Colors.Colors.GrayWarm9};

    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.tablet}px) {
      ${theme_LegacyTypography.LegacyTypography.paragraph3}
    }
  `
});
const TwoColumnStyles = styleEncapsulation.labelStyles("TestimonialTwoColumn", {
  outerBox: (backgroundColor = "neutral100") => react.css`
    ${styleMixins_reset.boxSizing};
    background-color: ${theme_Colors.Colors[theme_LegacyColorMap.LegacyColorMap[components_marketing_TestimonialSolo_TestimonialMapping.remapDeprecatedColors(backgroundColor)]]};
    padding: 20px;
    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.tablet}px) {
      padding: 72px 30px;
    }
    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.desktop}px) {
      padding: 82px 0px;
    }
  `,
  grid: react.css`
    ${styleMixins_reset.boxSizing};
    display: grid;
    grid-template-rows: auto;
    row-gap: 25px;
    max-width: 1170px;
    justify-content: center;
    margin: 0 auto;
    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.tablet}px) {
      grid-template-columns: auto 1px auto;
      column-gap: 15px;
      @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.desktop}px) {
        column-gap: 115px;
      }
    }
  `,
  content: react.css`
    ${styleMixins_reset.boxSizing};
    margin: 0 auto;
    text-align: center;
    max-width: 336px;

    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.tablet}px) {
      max-width: 339px;
    }

    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.desktop}px) {
      max-width: 370px;
    }
  `,
  avatarContainer: react.css`
    ${styleMixins_reset.boxSizing};
    margin-bottom: 10px;
    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.tablet}px) {
      margin-bottom: 20px;
    }
  `,
  border: react.css`
    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.tablet}px) {
      width: 1px;
      background-color: ${theme_Colors.Colors.GrayWarm4};
    }
  `
});
const ThreeColumnStyles = styleEncapsulation.labelStyles("TestimonialThreeColumn", {
  outerBox: (backgroundColor = "neutral100") => react.css`
    ${styleMixins_reset.boxSizing};
    background-color: ${theme_Colors.Colors[theme_LegacyColorMap.LegacyColorMap[components_marketing_TestimonialSolo_TestimonialMapping.remapDeprecatedColors(backgroundColor)]]};
    padding: 20px;
    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.tablet}px) {
      padding: 40px 0px;
    }
    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.desktop}px) {
      padding: 107px 0px;
    }
  `,
  grid: react.css`
    ${styleMixins_reset.boxSizing};
    display: grid;
    grid-template-rows: auto;
    row-gap: 40px;
    max-width: 1170px;
    justify-content: center;
    margin: 0 auto;
    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.tablet}px) {
      row-gap: 50px;
    }
    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.desktop}px) {
      grid-template-columns: auto auto auto;
      column-gap: 30px;
    }
  `,
  content: react.css`
    ${styleMixins_reset.boxSizing};
    margin: 0 auto;
    text-align: left;
    max-width: 336px;

    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.tablet}px) {
      max-width: 462px;
    }

    @media screen and (min-width: ${components_marketing_TestimonialSolo_TestimonialMapping.breakpoints.desktop}px) {
      max-width: 370px;
    }
  `,
  innerFlex: react.css`
    ${styleMixins_reset.boxSizing};
    display: flex;
    flex-direction: row;
    align-items: stretch;
    gap: 20px;
  `
});
const renderContentForTwoColumn = (props, index) => {
  return react.jsx(
    "div",
    { css: TwoColumnStyles.content, "data-zds": true },
    props.testimonials[index].hasAuthorAvatar && react.jsx(
      "div",
      { css: TwoColumnStyles.avatarContainer, "data-zds": true },
      react.jsx(components_display_Avatar_Avatar.Avatar, { "data-testId": "Avatar", name: props.testimonials[index].author, url: props.testimonials[index].avatarUrl, size: "medium" })
    ),
    react.jsx("div", { css: CommonStyles.quote, "data-zds": true }, props.testimonials[index].quote),
    react.jsx("p", { css: CommonStyles.author, "data-zds": true }, props.testimonials[index].author),
    react.jsx("p", { css: CommonStyles.company, "data-zds": true }, props.testimonials[index].company)
  );
};
const renderTwoColumn = (props) => {
  return react.jsx(
    "div",
    { css: TwoColumnStyles.outerBox(props.backgroundColor), "data-zds": true },
    react.jsx(
      "div",
      { css: TwoColumnStyles.grid, "data-zds": true },
      renderContentForTwoColumn(props, 0),
      react.jsx("div", { css: TwoColumnStyles.border, "data-zds": true }),
      renderContentForTwoColumn(props, 1)
    )
  );
};
const renderThreeColumn = (props) => {
  return react.jsx(
    "div",
    { css: ThreeColumnStyles.outerBox(props.backgroundColor), "data-zds": true },
    react.jsx("div", { css: ThreeColumnStyles.grid, "data-zds": true }, props.testimonials.slice(0, props.numberOfColumns).map((testimonial, index) => react.jsx(
      "div",
      { key: index, css: ThreeColumnStyles.content, "data-zds": true },
      react.jsx("div", { css: CommonStyles.quote, "data-zds": true }, testimonial.quote),
      testimonial.hasAuthorAvatar ? react.jsx(
        "div",
        { css: ThreeColumnStyles.innerFlex, "data-zds": true },
        react.jsx(
          "div",
          { css: TwoColumnStyles.avatarContainer, "data-zds": true },
          react.jsx(components_display_Avatar_Avatar.Avatar, { "data-testId": "Avatar", name: testimonial.author, url: testimonial.avatarUrl, size: "medium" })
        ),
        react.jsx(
          "div",
          { "data-zds": true },
          react.jsx("p", { css: CommonStyles.author, "data-zds": true }, testimonial.author),
          react.jsx("p", { css: CommonStyles.company, "data-zds": true }, testimonial.company)
        )
      ) : react.jsx(
        "div",
        { "data-zds": true },
        react.jsx("p", { css: CommonStyles.author, "data-zds": true }, testimonial.author),
        react.jsx("p", { css: CommonStyles.company, "data-zds": true }, testimonial.company)
      )
    )))
  );
};
const TestimonialMultipleColumn = (props) => {
  if (props.testimonials.length === 1) {
    const testimonial = props.testimonials[0];
    return react.jsx(components_marketing_TestimonialSolo_TestimonialSolo.TestimonialSolo, { backgroundColor: props.backgroundColor, avatarUrl: testimonial.avatarUrl, company: testimonial.company, quote: testimonial.quote, author: testimonial.author });
  }
  const renderType = props.numberOfColumns === 2 ? renderTwoColumn : renderThreeColumn;
  return renderType(props);
};

exports.TestimonialMultipleColumn = TestimonialMultipleColumn;
//# sourceMappingURL=TestimonialMultipleColumn.cjs.js.map
